import { createRouter, Router, createWebHistory, RouteRecordRaw  } from 'vue-router';
import i18n from '@/lang/i18n1'
const { locale } = i18n.global
const allowedLanguages = ['en-US', 'zh-CN', 'zh-TW']
import NotFoundView from '@/views/NotFoundView.vue'
const routes: Array<RouteRecordRaw> = [
  
  {
    path: '/',
    name: 'index',
    component: () => import("@/views/HomeView.vue"),
    children: [
      {
        path: ':lang?/walletPay',
        name: 'walletPay',
        component: () => import("@/views/HomeView.vue"),
      },
    ]
  },
];
const router: Router = createRouter({
  history: createWebHistory(),
  routes,
})



export default router